<template>
  <div>
    <div class="container">
      <!--    <div v-if="loading">-->
      <!--      <div class="overlay">-->
      <!--        <div class="loading"></div>-->
      <!--      </div>-->
      <!--    </div>-->
      <div class="col-lg-4 col-md-6 mt-3 ml-auto mr-auto">
        <form @submit.prevent="login()">
          <card class="card-login card-white">
            <template slot="header">
              <img src="/dist/img/card-primary.png" alt="" />
              <h1 class="card-title">Log in</h1>
            </template>

            <div>
              <base-input
                      required
                      v-model="user.email"
                      type="email"
                      placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"
              >
              </base-input>
              <validation-error :errors="apiValidationErrors.email" />

              <base-input
                      required
                      v-model="user.password"
                      placeholder="Parola"
                      addon-left-icon="tim-icons icon-lock-circle"
                      type="password"
              >
              </base-input>
              <validation-error :errors="apiValidationErrors.password" />
            </div>

            <div slot="footer">
              <base-button :loading="loading" native-type="submit" type="primary" class="mb-3" size="lg" block>
                Log in
              </base-button>
              <!--            <div class="pull-left">-->
              <!--              <h6>-->
              <!--                <router-link class="link footer-link" to="/register">-->
              <!--                  Creaza Cont-->
              <!--                </router-link>-->
              <!--              </h6>-->
              <!--            </div>-->
              <!--            <div class="pull-right">-->
              <!--              <h6>-->
              <!--                <router-link class="link footer-link" to="/password/reset">-->
              <!--                  Ai uitat parola?-->
              <!--                </router-link>-->
              <!--              </h6>-->
              <!--            </div>-->
            </div>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  import axios from "axios";

  export default {
    mixins: [formMixin],
    components: {
      ValidationError,
    },
    data() {
      return {
        user: {
          email: '',
          password: '',
        },
        loading: false,
        email: '',
        password: '',
      };
    },
    mounted() {
      if (this.$store.state.token !== '') {
        axios.post('/auth/checkToken')
                .then(res => {
                  if (res.data.success) {
                    this.$router.push('/dashboard');
                  } else {
                    this.$store.commit('setToken', res.data.token);
                    this.$store.commit('setUser', res.data.user);
                  }
                })
                .catch(err => {
                  // this.$store.commit('clearToken');
                })
      }
    },
    methods: {
      login() {
        this.loading = true;
        axios.post('/auth/login', this.user)
                .then(res => {
                  this.loading = false;
                  this.$store.commit('setToken', res.data.token);
                  this.$store.commit('setUser', res.data.user);
                  this.$router.push('/dashboard');
                })
                .catch(err => {
                  this.loading = false;
                  this.$notify({
                    message:'Credentiale invalide!',
                    icon: 'tim-icons icon-bell-55',
                    type: 'danger'
                  });
                  console.log(err);
                })
      },
    }
  };
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
